import React from "react";
import "../pages/boards/boardPills.css";

/** @typedef {'neutral' | 'green' | 'blue' | 'red' | 'amber' | 'purple' | 'working' | 'waiting' | 'stalled' | 'stage'} StatusPillVariant */

/**
 * Build class names for a status pill (for non-React or legacy call sites).
 * @param {StatusPillVariant} [variant='neutral']
 * @param {{ size?: 'sm' | 'md', uppercase?: boolean, className?: string }} [options]
 */
export function statusPillClass(variant = "neutral", options = {}) {
  const { size = "md", uppercase = false, className = "" } = options;
  return [
    "status-pill",
    `status-pill--${variant}`,
    size === "sm" ? "status-pill--sm" : "",
    uppercase ? "status-pill--uppercase" : "",
    className,
  ]
    .filter(Boolean)
    .join(" ");
}

/**
 * Canonical inline status / label chip — rounded rectangle, not a capsule pill.
 * Uses theme status tokens via boardPills.css (.status-pill aliases .board-pill).
 */
export default function StatusPill({
  variant = "neutral",
  size = "md",
  uppercase = false,
  className = "",
  style,
  children,
  ...props
}) {
  return (
    <span
      className={statusPillClass(variant, { size, uppercase, className })}
      style={style}
      {...props}
    >
      {children}
    </span>
  );
}
